export function getProductTypeName(type) {
  switch (type) {
    case 'VIRTUAL_DISPATCHER':
      return 'Despachante virtual';
    default:
      return 'Padrão';
  }
}
